var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIntegration = function SvgIntegration(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "none",
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8.176 13H5a4 4 0 0 0-4 4 2 2 0 0 0 2 2h5.176M15 16h.01M13 5a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm2 7 1.179 1.155 1.65.017.017 1.65L19 16l-1.154 1.179-.018 1.65-1.65.017L15 20l-1.179-1.154-1.65-.018-.016-1.65L11 16l1.155-1.179.017-1.65 1.65-.016L15 12Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIntegration);
export default ForwardRef;